// eslint-disable-next-line no-restricted-imports

import type { SingleRouteType } from '@crehana/web';
// biome-ignore lint/style/noRestrictedImports: legacy import kept for compatibility
import { matchPath, Redirect, Route } from 'react-router-dom';

import RevampDetailTrack from '../layouts/b2b/RevampDetailTrack';

type HomeRoutesProps = {
  routes: SingleRouteType[];
  redirectPath: string;
};

/**
 * HomeRoutes component renders provided routes and handles a special route for tracks
 * as well as fallback redirects for non-existent routes.
 *
 * @param {HomeRoutesProps} props - Component props
 * @returns React component that renders routes based on the current location
 */
export const HomeRoutes: React.FC<HomeRoutesProps> = ({
  routes,
  redirectPath,
}) => {
  const TRACK_DETAIL_ROUTE_PATTERN = 'my-courses/tracks/:id';
  const TRACKS_ROUTE_PATH = `${redirectPath}${TRACK_DETAIL_ROUTE_PATTERN}`;

  return (
    <>
      <Route key="DETAIL_TRACKS" path={TRACKS_ROUTE_PATH} exact>
        <RevampDetailTrack />
      </Route>

      {routes.map(route => (
        <Route key={route.key} path={route.path} exact={route.exact}>
          <route.component />
        </Route>
      ))}

      {/* Fallback route for non-matching paths */}
      <Route path="*">
        {({ location }) => {
          // Check if this path already matched a rendered route
          const matchesTracksRoute = matchPath(location.pathname, {
            path: TRACKS_ROUTE_PATH,
            exact: true,
          });

          // If it matches the tracks route, don't do anything as it's already handled
          if (matchesTracksRoute) {
            return null;
          }

          // Check if it matches any of the defined routes
          const matchesAnyRoute = routes.some(route =>
            matchPath(location.pathname, {
              path: route.path,
              exact: route.exact,
            }),
          );

          return matchesAnyRoute ? null : <Redirect to={redirectPath} />;
        }}
      </Route>
    </>
  );
};
